// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group label[data-v-d40a3402]{font-weight:bold}.card-header[data-v-d40a3402]{border:1px solid var(--header-problem-card-color);border-bottom:none;background-color:var(--header-problem-card-color-no-opacity)}@media(max-width: 576px){.button-mobile[data-v-d40a3402]{margin-left:1rem}.form-control[data-v-d40a3402]{margin-left:0 !important}}", ""]);
// Exports
module.exports = exports;
